 var baseUrl = "https://api-dev-elikia-funding.fewnu.app/api/";
//  var baseUrl = "https://api-recette-elikia-funding.fewnu.app/api/";
//  var baseUrl = "https://api-easy-funding.fewnu.app/api/";
//  var baseUrl = "http://127.0.0.1/api/";

export default baseUrl;


